import { Button } from '@platform/components';
import { useEffect, useState } from 'react';
import GoogleLogo from './google_logo.svg';

export const GoogleSignInButton = () => {
  const [loginTarget, setLoginTarget] = useState('http://localhost:8000/api/login/google');

  useEffect(() => {
    setLoginTarget(
      window && window.location.hostname !== 'localhost' ?
        import.meta.env.VITE_API_HOST + '/login/google'
      : 'http://localhost:8000/api/login/google',
    );
  }, []);

  return (
    <div>
      <Button href={loginTarget} variant='secondary-gray' size='lg' additionalClassnames='w-full'>
        <img src={GoogleLogo} /> {'Log in with Google'}
      </Button>
    </div>
  );
};
